(function (module) {
    "use strict";

    module.service("priceListLoadService", ['mlDataService', priceListLoadService]);

    function priceListLoadService(this: $TSFixMe, mlDataService: $TSFixMe) {
        const service = this;

        service.buttonTranslationKey = 'FORECAST.PRODUCT.MKSHR_BRAND_IN_MARKET.LOAD_PRICE';

        service.getPrices = (brand: $TSFixMe, parameters: $TSFixMe) => {
            
            var forecastLength = Math.floor(moment.utc(parameters.forecastEndDate).diff(moment.utc(parameters.forecastStartDate), 'months')) + 1;
            return mlDataService.getPrices(brand.skus.map((s: $TSFixMe) => s.oracleIndex)).then((dict: $TSFixMe) => {
                var newDict = {};
                for (var oracleIndex in dict) {
                    // @ts-expect-error ts-migrate(7053) FIXME: Element implicitly has an 'any' type because expre... Remove this comment to see the full error message
                    newDict[oracleIndex] = _.times(forecastLength, _.constant(dict[oracleIndex]));
                }
                return newDict;
            });
        }
    }


})(angular.module('topline.services'));